// components/PitchDeck/02_Problem.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Problem() {
    return (
        <div className="min-h-screen flex items-center bg-gray-50 py-20">
            <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    The Problem
                </h2>
                <p className="text-2xl md:text-3xl text-gray-800 max-w-4xl mx-auto leading-relaxed">
                    Nigerian business owners know their goals — but lack the discipline, structures, and compliance tools to achieve them reliably.
                </p>
                <div className="mt-16 grid md:grid-cols-3 gap-8">
                    <div className="bg-white p-8 rounded-2xl shadow-lg">
                        <p className="text-xl font-semibold text-red-600 mb-4">Manual Chaos</p>
                        <p className="text-lg text-gray-700">Excel, paper receipts, and guesswork lead to errors, missed taxes, and cash flow surprises.</p>
                    </div>
                    <div className="bg-white p-8 rounded-2xl shadow-lg">
                        <p className="text-xl font-semibold text-red-600 mb-4">Compliance Nightmares</p>
                        <p className="text-lg text-gray-700">VAT, withholding tax, and FIRS filings are dreaded — penalties kill small profits.</p>
                    </div>
                    <div className="bg-white p-8 rounded-2xl shadow-lg">
                        <p className="text-xl font-semibold text-red-600 mb-4">No Real Oversight</p>
                        <p className="text-lg text-gray-700">Owners lack visibility — manual reconciliation, bad debts, understated costs, inefficiencies go unnoticed.</p>
                    </div>
                </div>
                <p className="mt-12 text-2xl font-bold text-gray-900">
                    Result: Wishful thinking instead of sustainable growth.
                </p>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/solution">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}